import type { UserBookingInfo } from '@/api/types';

export const VIEWABLE_BOOKING_STATUSES = [
  'CONFIRMED',
  'PENDING_PAYMENT',
  'PENDING_APPROVAL',
  'WAITLISTED',
] as const;

const VIEWABLE_BOOKING_STATUS_SET = new Set<string>(VIEWABLE_BOOKING_STATUSES);

const BOOKED_BADGE_LABELS: Record<string, string> = {
  CONFIRMED: "You're booked",
  PENDING_PAYMENT: 'Awaiting payment',
  PENDING_APPROVAL: 'Pending approval',
  WAITLISTED: 'Waitlisted',
};

export function isViewableBooking(
  booking: UserBookingInfo | null,
): booking is UserBookingInfo {
  return booking !== null && VIEWABLE_BOOKING_STATUS_SET.has(booking.status);
}

export function bookedBadgeLabel(status: string): string | null {
  return BOOKED_BADGE_LABELS[status] ?? null;
}
